const LOGIN_PATH = '/login';
const LOGIN_SSO_PATH = '/loginsso';
const FORGOT_PASSWORD_PATH = '/forgot-pass';
const RECOVER_PASSWORD_PATH = '/recover-pass';
const ACCOUNT_PATH = '/account';
const ACCOUNT_PATH_ADD = `${ACCOUNT_PATH}/add`;
const ACCOUNT_PATH_EDIT = `${ACCOUNT_PATH}/edit`;
const LOGIN_HISTORY_PATH = '/login-history';
const STATISTIC_HISTORY_PATH = '/statistic-login-history';

const EMAILCONFIG_PATH = '/emailconfig';
const EMAILCONFIG_CREATE_PATH = '/emailconfig/create';
const EMAILCONFIG_EDIT_PATH = '/emailconfig/edit';

const LOG_PATH = '/log';

const REPORT_POST_PATH = '/report-post';
const REPORT_POST_SYNTHETIC_PATH = '/report-post-synthentic';
const REPORT_POST_EXCEL_PATH = '/report-post-excel';
const REPORT_POST_EXCEL_QUANTITY_CREATE_BY =
    '/report-post-excel-quantity-createby';
const REPORT_POST_EXCEL_CREATE_BY = '/report-post-excel-createby';

const REPORT_POST_WEBANALYSIS_PATH = '/report-post-web-analysis';
const REPORT_POST_BY_DATETYPE = '/report-post-by-datetype';
const REPORT_POST_VIEW_DETAIL = '/report-post-view-detail';
const REPORT_POST_PUBLISHTIME_DATATYPE_PATH =
    '/report-post-publish-time-data-type';
const REPORT_ADVERTISING_ANALYSIS_PATH = '/advertising-analysis';
const REPORT_COUNT_VISIT_DETAIL = '/report-count-visit-detail';

const DONVIDENGHI_PATH = '/don-vi-de-nghi';
const DONVIDENGHI_CREATE_PATH = `${DONVIDENGHI_PATH}/them`;
const DONVIDENGHI_EDIT_PATH = `${DONVIDENGHI_PATH}/sua`;

const APIROLEMAPPING_PATH = '/api-role-mapping';
const APIROLEMAPPING_CREATE_PATH = `${APIROLEMAPPING_PATH}/them`;
const APIROLEMAPPING_EDIT_PATH = `${APIROLEMAPPING_PATH}/sua`;

const OPENIDDICTAPPLICATION_PATH = '/ung-dung-dang-ky';
const OPENIDDICTAPPLICATION_CREATE_PATH = `${OPENIDDICTAPPLICATION_PATH}/them`;
const OPENIDDICTAPPLICATION_EDIT_PATH = `${OPENIDDICTAPPLICATION_PATH}/sua`;

const MENUITEM_PATH = '/menu';
const MENUITEM_CREATE_PATH = `${MENUITEM_PATH}/them`;
const MENUITEM_EDIT_PATH = `${MENUITEM_PATH}/sua`;

const BAOCAO_PATH = '/bao-cao';

const ROLE_ACCOUNT_PATH = '/role-account';
const ROLE_ACCOUNT_CREATE_PATH = '/role-account/create';
const ROLE_ACCOUNT_EDIT_PATH = '/role-account/edit';

const KYSO_PATH = '/ky-so';

//App dung chung
const DONVI_PATH = '/don-vi';
const DONVI_CREATE_PATH = `${DONVI_PATH}/them`;
const DONVI_EDIT_PATH = `${DONVI_PATH}/sua`;

const CHUCVU_PATH = '/chuc-vu';
const CHUCVU_CREATE_PATH = `${CHUCVU_PATH}/them`;
const CHUCVU_EDIT_PATH = `${CHUCVU_PATH}/sua`;

const CHUYENMON_PATH = '/chuyen-mon';
const CHUYENMON_CREATE_PATH = `${CHUYENMON_PATH}/them`;
const CHUYENMON_EDIT_PATH = `${CHUYENMON_PATH}/sua`;

const DONVIDAOTAO_PATH = '/don-vi-dao-tao';
const DONVIDAOTAO_CREATE_PATH = `${DONVIDAOTAO_PATH}/them`;
const DONVIDAOTAO_EDIT_PATH = `${DONVIDAOTAO_PATH}/sua`;

const HINHTHUCDAOTAO_PATH = '/hinh-thuc-dao-tao';
const HINHTHUCDAOTAO_CREATE_PATH = `${HINHTHUCDAOTAO_PATH}/them`;
const HINHTHUCDAOTAO_EDIT_PATH = `${HINHTHUCDAOTAO_PATH}/sua`;

const NGANHDAOTAO_PATH = '/nganh-dao-tao';
const NGANHDAOTAO_CREATE_PATH = `${NGANHDAOTAO_PATH}/them`;
const NGANHDAOTAO_EDIT_PATH = `${NGANHDAOTAO_PATH}/sua`;

const TRINHDO_PATH = '/trinh-do';
const TRINHDO_CREATE_PATH = `${TRINHDO_PATH}/them`;
const TRINHDO_EDIT_PATH = `${TRINHDO_PATH}/sua`;

const XEPLOAIDAOTAO_PATH = '/xep-loai-dao-tao';
const XEPLOAIDAOTAO_CREATE_PATH = `${XEPLOAIDAOTAO_PATH}/them`;
const XEPLOAIDAOTAO_EDIT_PATH = `${XEPLOAIDAOTAO_PATH}/sua`;

const DOITUONG_PATH = '/doi-tuong';
const DOITUONG_CREATE_PATH = `${DOITUONG_PATH}/them`;
const DOITUONG_EDIT_PATH = `${DOITUONG_PATH}/sua`;

const ACCOUNTINFO_PATH = '/account-info';
const ACCOUNTINFO_CREATE_PATH = `${ACCOUNTINFO_PATH}/them`;
const ACCOUNTINFO_EDIT_PATH = `${ACCOUNTINFO_PATH}/sua`;

const QUATRINHDAOTAO_PATH = '/qua-trinh-dao-tao';
const QUATRINHDAOTAO_CREATE_PATH = `${QUATRINHDAOTAO_PATH}/them`;
const QUATRINHDAOTAO_EDIT_PATH = `${QUATRINHDAOTAO_PATH}/sua`;

export const URI_INTERNAL = {
    REPORT_ADVERTISING_ANALYSIS_PATH,
    REPORT_POST_VIEW_DETAIL,
    REPORT_POST_BY_DATETYPE,
    REPORT_POST_EXCEL_CREATE_BY,
    REPORT_POST_EXCEL_QUANTITY_CREATE_BY,
    REPORT_POST_SYNTHETIC_PATH,
    REPORT_POST_PATH,
    RECOVER_PASSWORD_PATH,
    FORGOT_PASSWORD_PATH,
    ACCOUNT_PATH_EDIT,
    ACCOUNT_PATH_ADD,
    LOGIN_PATH,
    LOGIN_SSO_PATH,
    ACCOUNT_PATH,
    LOGIN_HISTORY_PATH,
    EMAILCONFIG_PATH,
    EMAILCONFIG_CREATE_PATH,
    EMAILCONFIG_EDIT_PATH,
    STATISTIC_HISTORY_PATH,
    LOG_PATH,
    REPORT_POST_EXCEL_PATH,
    REPORT_POST_WEBANALYSIS_PATH,
    REPORT_POST_PUBLISHTIME_DATATYPE_PATH,
    REPORT_COUNT_VISIT_DETAIL,

    DONVIDENGHI_PATH,
    DONVIDENGHI_CREATE_PATH,
    DONVIDENGHI_EDIT_PATH,

    APIROLEMAPPING_PATH,
    APIROLEMAPPING_CREATE_PATH,
    APIROLEMAPPING_EDIT_PATH,

    OPENIDDICTAPPLICATION_PATH,
    OPENIDDICTAPPLICATION_CREATE_PATH,
    OPENIDDICTAPPLICATION_EDIT_PATH,

    MENUITEM_PATH,
    MENUITEM_CREATE_PATH,
    MENUITEM_EDIT_PATH,

    ROLE_ACCOUNT_PATH,
    ROLE_ACCOUNT_CREATE_PATH,
    ROLE_ACCOUNT_EDIT_PATH,

    BAOCAO_PATH,

    KYSO_PATH,

    // App dung chung
    CHUCVU_PATH,
    CHUCVU_CREATE_PATH,
    CHUCVU_EDIT_PATH,
    CHUYENMON_PATH,
    CHUYENMON_CREATE_PATH,
    CHUYENMON_EDIT_PATH,
    DONVIDAOTAO_PATH,
    DONVIDAOTAO_CREATE_PATH,
    DONVIDAOTAO_EDIT_PATH,
    HINHTHUCDAOTAO_PATH,
    HINHTHUCDAOTAO_CREATE_PATH,
    HINHTHUCDAOTAO_EDIT_PATH,
    NGANHDAOTAO_PATH,
    NGANHDAOTAO_CREATE_PATH,
    NGANHDAOTAO_EDIT_PATH,
    TRINHDO_PATH,
    TRINHDO_CREATE_PATH,
    TRINHDO_EDIT_PATH,
    XEPLOAIDAOTAO_PATH,
    XEPLOAIDAOTAO_CREATE_PATH,
    XEPLOAIDAOTAO_EDIT_PATH,
    DOITUONG_PATH,
    DOITUONG_CREATE_PATH,
    DOITUONG_EDIT_PATH,
    ACCOUNTINFO_PATH,
    ACCOUNTINFO_CREATE_PATH,
    ACCOUNTINFO_EDIT_PATH,
    QUATRINHDAOTAO_PATH,
    QUATRINHDAOTAO_CREATE_PATH,
    QUATRINHDAOTAO_EDIT_PATH,
    DONVI_PATH,
    DONVI_CREATE_PATH,
    DONVI_EDIT_PATH
};
